<ng-container *transloco="let t">
  <ng-container *ngIf="(isDirty$ | async) && (isInvalid$ | async); then error; else empty"></ng-container>

  <ng-template #error>
    <div class="error" *ngFor="let error of errors$ | async">{{t('messages.' + error)}}</div>
  </ng-template>

  <ng-template #empty></ng-template>
</ng-container>
